module.exports = __webpack_public_path__ + "static/media/keyboard-arrow-left.65c6a982.svg";